/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Block_Reverse_Charge_BodyInputs */



/**
* | output |
* | --- |
* | "EU customer outside Germany — reverse charge. Confirmed, but not yet mapped in the accounting system. Amounts keep accruing." |
*
* @param {Partner_Detail_Block_Reverse_Charge_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_block_reverse_charge_body = /** @type {((inputs?: Partner_Detail_Block_Reverse_Charge_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Block_Reverse_Charge_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("EU-Kunde außerhalb Deutschlands — Reverse-Charge. Bestätigt, aber noch nicht in der Buchhaltung abgebildet. Die Beträge laufen weiter auf.")
	return /** @type {LocalizedString} */ ("EU customer outside Germany — reverse charge. Confirmed, but not yet mapped in the accounting system. Amounts keep accruing.")
});